import { Component } from '@angular/core';

@Component({
  selector: 'app-close-preview-icon',
  imports: [],
  templateUrl: './close-preview-icon.html',
  styleUrl: './close-preview-icon.scss',
})
export class ClosePreviewIcon {

}
